import React from 'react'
import moment from 'moment'
import sumBy from 'lodash/fp/sumBy'
import { useTranslation } from 'react-i18next'

import { minutesToHours } from '@cbgms/base/utils/datetime'

import Day, { createDurationTime } from './Day'
import { Divider, Grid, TextField, Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import Breaks from './Breaks'

export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const

interface IFormProps {
  BreakTimes?: {
    Times?: object[]
  }
}

const TotalOpeningHours: React.FC = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext<{ [key: string]: string }>()
  const totalMinutes = sumBy(day => createDurationTime(values, day), WEEK_DAYS)

  return (
    <Grid container columns={5} spacing={2}>
      <Grid item xs />
      <Grid item xs />
      <Grid item xs sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontWeight: 700 }}>
        {t('setting_opening_hour.total')}
      </Grid>
      <Grid item xs>
        <TextField
          fullWidth
          size='small'
          name='TotalDurationHours'
          value={totalMinutes ? moment.duration(totalMinutes, 'minutes').format('HH:mm', { trim: false }) : '00:00'}
          inputProps={{ maxLength: 6, readOnly: true }}
        />
      </Grid>
      <Grid item xs>
        <TextField
          fullWidth
          size='small'
          name='TotalDurationUnits'
          value={minutesToHours(totalMinutes)}
          inputProps={{ maxLength: 6, readOnly: true }}
        />
      </Grid>
    </Grid>
  )
}

export const FormFields: React.FC<IFormProps> = () => {
  const { t } = useTranslation()

  return (
    <>
      <Grid container columns={5} spacing={2} sx={{ fontWeight: '700' }}>
        <Grid item xs />
        <Grid item xs>
          {t('setting_opening_hour.start_time')}
        </Grid>
        <Grid item xs>
          {t('setting_opening_hour.end_time')}
        </Grid>
        <Grid item xs>
          {t('setting_opening_hour.duration_time')}
        </Grid>
        <Grid item xs>
          {t('setting_opening_hour.duration_units')}
        </Grid>
      </Grid>

      {WEEK_DAYS.map(day => (
        <Day day={day} key={day} />
      ))}

      <TotalOpeningHours />

      <Divider sx={{ my: 2 }} />
      <Typography variant='h6'>{t('setting_opening_hour.break_times')}</Typography>
      <Breaks />
    </>
  )
}

FormFields.displayName = 'OpeningHourFormFields'

export default FormFields
